<template>
  <div class="sankey-chart">
    <svg ref="mainSvg" width="1200" height="700">
      <defs>
        <pattern id="tranformation-fill" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <rect width="4" height="8" transform="translate(0,0)" fill="red"></rect>
        </pattern>
      </defs>
    </svg>
    <!--<button @click="exportSvg">export SVG</button>-->
  </div>
</template>

<script>
import d3 from '@/utils/d3importer'
import _ from 'underscore'
import saveSVG from "@/utils/saveSVG";
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'; // optional for styling
import ChartTooltip from './ChartTooltip'
import Vue from 'vue'

export default {
  name: 'SankeyChart',
  data () {
    return {
      expandedView: true
    }
  },
  props: ['chartData'],
  mounted () {
    this.initChart()
  },
  computed: {
    sankeyData () {
      let graph = {nodes: [], links: []}
      this.chartData.forEach((d,i) => {
        let productId = this.makeId('products_' + d['Products'] + '_' + d['Origin'])
        //add raw material
        let sourcingId = productId + '_sourcing'
        if (graph.nodes.find(n => n.id == sourcingId)) {
          let sIndex = graph.nodes.findIndex(n => n.id == sourcingId)
          graph.nodes[sIndex].realValue = graph.nodes[sIndex].realValue + +d['Sourcing']
          graph.nodes[sIndex].fixedValue = Math.abs(graph.nodes[sIndex].realValue)
        }
        else {
          graph.nodes.push({
            id: sourcingId,
            name: d['Products'],
            type: 'raw',
            realValue: +d['Sourcing'],
            fixedValue: Math.abs(+d['Sourcing'])
          })
        }

        //add Product
        let prodVal = +d['Average Embodied Carbon (kg CO2e)']
        if (graph.nodes.find(n => n.id == productId)) {
          let pIndex = graph.nodes.findIndex(n => n.id == productId)
          graph.nodes[pIndex].realValue =  graph.nodes[pIndex].realValue + prodVal
          graph.nodes[pIndex].fixedValue = Math.abs(graph.nodes[pIndex].realValue)
        }
        else {
          graph.nodes.push({
            id: productId,
            name: d['Products'] + (d['Origin'] ?  ` (${d['Origin']})`  : ''),
            realValue: prodVal,
            type: 'product',
            transformValue: 0,
            fixedValue: Math.abs(prodVal)
          })
        }

        let trans1Id = this.makeId(productId + '_tans1')
        let trans2Id = this.makeId(productId + '_tans2')
        
        if(this.expandedView){
          //add T1
          let t1EnterVal = +d['Sourcing'] + +d['Transport 1']
          let t1ExitVal = t1EnterVal + +d['Transformation 1']
          if (graph.nodes.find(n => n.id == trans1Id)) {
            let t1Index = graph.nodes.findIndex(n => n.id == trans1Id)
            graph.nodes[t1Index].realValue += t1EnterVal
            graph.nodes[t1Index].transformValue += d['Transformation 1']
            graph.nodes[t1Index].fixedValue += Math.max(Math.abs(t1EnterVal), Math.abs(t1ExitVal))
          }
          else {
            graph.nodes.push({
              id: trans1Id,
              name: d['Products'],
              type: 't1',
              realValue: t1EnterVal,
              transformDescription: d['T1 description'],
              transformValue: +d['Transformation 1'],
              fixedValue: Math.max(Math.abs(t1EnterVal), Math.abs(t1ExitVal)),
            })
          }
          graph.links.push(
            { "source": trans1Id,
              "target": sourcingId,
              "transportValue": +d['Transport 1'],
              "value": Math.abs(t1EnterVal)
            })

          //add T2
          let t2EnterVal = t1ExitVal + +d['Transport 2']
          let t2ExitVal = t2EnterVal + +d['Transformation 2']
          if (graph.nodes.find(n => n.id == trans2Id)) {
            let t2Index = graph.nodes.findIndex(n => n.id == trans2Id)
            graph.nodes[t2Index].realValue += t2EnterVal
            graph.nodes[t2Index].transformValue += +d['Transformation 2']
            graph.nodes[t2Index].fixedValue += Math.max(Math.abs(t2EnterVal), Math.abs(t2ExitVal))
          } else {
            graph.nodes.push({
              id: trans2Id,
              type: 't2',
              name: d['Products'],
              realValue: t2EnterVal,
              transformDescription: d['T2 description'],
              transformValue: +d['Transformation 2'],
              fixedValue: Math.max(Math.abs(t2EnterVal), Math.abs(t2ExitVal))
            })
          }
          graph.links.push(
          { "source": trans2Id,
            "target": trans1Id,
            "transportValue": +d['Transport 2'],
            "value": Math.abs(t1ExitVal)
          })

          if(d['Transformation 2'] != null) {
          graph.links.push(
          { "source": productId,
            "target": trans2Id,
            "value": Math.abs(t2ExitVal)
          })
          } else {
            graph.links.push(
            { "source": productId,
              "target": trans1Id,
              "value": Math.abs(t1ExitVal)
            })
          }
        }

        

        if(this.expandedView) {
          
        } else {
          // Skip Trans1 and trans 2
          graph.links.push(
            { "source": productId,
              "target": sourcingId,
              "value": Math.abs(prodVal),
              "transportValue": +d['Transport 1'] + +d['Transport 2'],
            })
        }
        

        let compId = this.makeId('component_' + d['Component'])
        if(this.expandedView){
          // Add Component
          if (graph.nodes.find(n => n.id == compId)) {
            let cIndex = graph.nodes.findIndex(n => n.id == compId)
            graph.nodes[cIndex].realValue = graph.nodes[cIndex].realValue + prodVal
            graph.nodes[cIndex].fixedValue = Math.abs(graph.nodes[cIndex].realValue)
          }
          else {
            graph.nodes.push({
              id: compId,
              type: 'component',
              name: d['Component'],
              realValue: prodVal,
              transformValue: 0,
              fixedValue: Math.abs(prodVal)
            })
          }
          graph.links.push(
            { "source": compId,
              "target": productId,
              "value": Math.abs(prodVal)
            })
        }

        // Add Assembly
        let assId = this.makeId('assembly_' + d['Assembly'])
        if (graph.nodes.find(n => n.id == assId)) {
          let aIndex = graph.nodes.findIndex(n => n.id == assId)
          graph.nodes[aIndex].realValue += prodVal
          graph.nodes[aIndex].fixedValue += Math.abs(prodVal)
        }
        else {
          graph.nodes.push({
            id: assId,
            type: 'assembly',
            name: d['Assembly'],
            realValue: prodVal,
            transformValue: 0,
            fixedValue: Math.abs(prodVal)
          })
        }

        if(this.expandedView) {
          graph.links.push(
          { "source": assId,
            "target": compId,
            "value": Math.abs(prodVal)
          })
        } else {
          graph.links.push(
          { "source": assId,
            "target": productId,
            "value": Math.abs(prodVal)
          })
        }
      })

      return graph
    }
  },
  methods: {
    exportSvg () {
      saveSVG(this.$refs.mainSvg, 'Sankey');
    },
    makeId (val) {
      return val.replace(/^[^a-z]+|[^\w:.-]+/gi, "");
    },
    initChart () {
    },
    drawChart () {
      let self = this
      let graph = this.sankeyData
      var margin = {top: 50, right: 30, bottom: 10, left: 30},
          width = this.$el.clientWidth - margin.left - margin.right,
          height = 600 - margin.top - margin.bottom;

      var formatNumber = d3.format(",.0f"),    // zero decimal places
          format = function(d) { return formatNumber(d); }

      // append the svg canvas to the page
      var svg = d3.select(this.$refs.mainSvg)
          .attr("width", width + margin.left + margin.right)
          .attr("height", height + margin.top + margin.bottom)
          .append("g")
          .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")");

      

      let sankey = d3.sankey()
        .nodeId(d => d.id)
        //.nodeAlign(d3[`sankey${align[0].toUpperCase()}${align.slice(1)}`])
        //.nodeSort(inputOrder ? null : undefined)
        .nodeWidth(30)
        .nodePadding(10)
        .extent([[0, 0], [width, height - 5]])

      let sankeyChart = sankey({
        nodes: _.uniq(graph.nodes.map(d => Object.assign({}, d)), d => d.id),
        links: graph.links.map(d => Object.assign({}, d))
      });

      let nodesGroups = svg.append("g")
        .selectAll(".nodes-g")
        .data(sankeyChart.nodes)
        .join("g")
        .attr("class", d => "nodes-g " + d.type)
        .attr("id", d => d.id)

      nodesGroups
          .append("rect")
          .attr("class", "exit-height")
          .attr("x", d => d.x0)
          .attr("y", d => {
            let h = d.y1 - d.y0
            let transf = d.transformValue ? d.transformValue : 0
            return d.y1 - (Math.abs(d.realValue + transf) / d.fixedValue * h)
          })
          .attr("height", d => {
            let h = d.y1 - d.y0
            let transf = d.transformValue ? d.transformValue : 0
            return Math.abs(d.realValue + transf) / d.fixedValue * h
          })
          .attr("width", 2)
          .attr("fill", 'black')

      nodesGroups
          .append("rect")
          .attr("class", "enter-height")
          .attr("x", d => d.x1 - 2)
          .attr("y", d => {
            let h = d.y1 - d.y0
            let enterVal = Math.max(Math.abs(d.realValue), Math.abs(d.fixedValue - d.transformValue))
            return d.y1 - (enterVal / d.fixedValue * h)
          })
          .attr("height", d => {
            let h = d.y1 - d.y0
            let enterVal = Math.max(Math.abs(d.realValue), Math.abs(d.fixedValue - d.transformValue))
            return enterVal / d.fixedValue * h
          })
          .attr("width", 2)
          .attr("fill", 'black')

      nodesGroups
          .append("rect")
          .attr("class", "item-height")
          .attr("x", d => d.x0 + 5)
          .attr("y", d => {
            let h = d.y1 - d.y0
            return d.y1 - (Math.abs(d.realValue) / d.fixedValue * h)
          })
          .attr("height", d => {
            let h = d.y1 - d.y0
            return Math.abs(d.realValue) / d.fixedValue * h
          })
          .attr("width", d => d.x1 - d.x0 - 10)
          .attr("fill", d => {
            let realValue = d.realValue || _.reduce(d.sourceLinks, (memo, l) => memo + l.realValue , 0)
            return realValue > 0 ? '#ff0000' : '#00ff00'
          })

        nodesGroups.each(function (d) {
            tippy(this, {
              trigger: 'mouseenter',
              animation: 'fade',
              interactive: true,
              arrow: true,
              appendTo: document.body,
              content: self.tooltipContent(d),
              onTrigger (instance, event) {
                self.closeTooltips()
              }
            })
          })
        nodesGroups.on('click', this.clickNode)

      nodesGroups
        .append("rect")
          .attr("class", "transformation")
          .style("fill", "url(#tranformation-fill)")
          .attr("x", d => d.x0 + 5)
          .attr("y", d => d.y0)
          .attr("height", d => {
            return d.transformValue ? (d.y1 - d.y0) * (d.transformValue / d.fixedValue) : 0
          })
          .attr("width", d => d.x1 - d.x0 - 10)
          .attr('opacity', 0.5)

      /*
      const link = svg.append("g")
          .attr("fill", "none")
        .selectAll("g")
        .data(sankeyChart.links)
        .join("g")
          .attr("stroke", d => {
            return d.target.realValue > 0 ? '#ff0000' : '#00ff00'
          })
          //.attr("stroke", d => d.value > 0 ? '#ff0000' : '#00ff00')
          //.attr("fill", d => d.value > 0 ? '#ff0000' : '#00ff00')
          .style("mix-blend-mode", "multiply")
          .attr("opacity", 0.2)
  
      link.append("path")
          .attr("d", d3.sankeyLinkHorizontal())
          .attr("stroke-width", d => Math.max(1, d.width));
      link.append("title")
          .text(d => `${d.source.name} → ${d.target.name}\n${d.value.toLocaleString()}`);
      */
     let customLinks = svg.append("g")
          .attr("fill", "none")
          .selectAll("polygon")
          .data(sankeyChart.links)
          .join("polygon")
          .attr("class", "links-g")
          .attr("id", d => 'link-' + d.index)
          .attr("points", link => { 
            // TODO draw points based on values
            let {source, target} = link
            let valueToPixelRatio = link.width / link.value

            //source offset
            let sourceH = source.y1 - source.y0
            let sourceEnterVal = Math.max(Math.abs(source.realValue), Math.abs(source.fixedValue - source.transformValue))
            let sourceOffset = (source.fixedValue - sourceEnterVal) * valueToPixelRatio
            link.y0 = link.y0 + sourceOffset

            //target offset
            let targetH = target.y1 - target.y0
            let targetTransf = target.transformValue ? target.transformValue : 0
            let targetExitValue = Math.abs(target.realValue + targetTransf)
            let targetOffset = (target.fixedValue - targetExitValue) * valueToPixelRatio
            link.y1 = link.y1 + targetOffset

            link.transportValue = link.transportValue ? link.transportValue : 0
            link.targetWidth = link.width - (link.transportValue * valueToPixelRatio)
            //
            return [
              [source.x1, link.y0 - link.width/2],
              [target.x0, link.y1 - link.targetWidth/2],
              [target.x0, link.y1 + link.targetWidth/2],
              [source.x1, link.y0 + link.width/2]
            ]

          })
          .attr("fill", d => d.target.realValue > 0 ? '#ff0000' : '#00ff00')
          .style("mix-blend-mode", "multiply")
          .attr("opacity", 0.2)
      
      svg.append("g")
          .style("font", "10px sans-serif")
        .selectAll("text")
        .data(sankeyChart.nodes)
        .join("text")
          .attr("x", d => d.x0 < width / 2 ? d.x1 + 6 : d.x0 - 6)
          .attr("y", d => (d.y1 + d.y0) / 2)
          .attr("dy", "0.35em")
          .attr("text-anchor", d => d.x0 < width / 2 ? "start" : "end")
          //.attr("text-anchor", "start")
          .text(d => d.fixedValue > 100 &&  !['t1','t2'].includes(d.type) ? d.name : '')
        /*.append("tspan")
          .attr("fill-opacity", 0.7)
          .attr("x", d => d.x0 < width / 2 ? d.x1 + 6 : d.x0 - 6)
          .attr("y", d => ((d.y1 + d.y0) / 2) +13 )
          .text(d => d.fixedValue > 200 ? ` ${d.realValue.toLocaleString()}` : '');
        */

      // draw references
      let depths = _.uniq(sankeyChart.nodes, d=> d.depth)

      let references = svg.append("g")
        .selectAll(".reference")
        .data(depths)
        .join("g")
        .attr("class", "reference")
        .attr("transform",
                d => "translate(" +(d.x0 + d.x1)/2 + ", -30)")

      let referenceLabels = this.expandedView ? ['Assembly', 'Component', 'Product', 'Transformation 2', 'Transformation 1', 'Raw material'] : ['Assembly', 'Product', 'Raw material']
      references.append("circle")
        .attr("r", 5)
        .attr("cy", 15)
        .attr("stroke", "#000000")
        .attr("stroke-width", 2)
        .attr("fill", "none")
      references.append("text")
        .style("font", "12px sans-serif")
        .attr("text-anchor", "middle")
        .text(d => referenceLabels[d.depth])

    },
    tooltipContent (data) {
      var ComponentClass = Vue.extend(ChartTooltip)
      if (data) {
        var instance = new ComponentClass({
          propsData: {
            'item': data,
            'type': data.type
          },
          store: this.$store
        })
        instance.$mount()
        return instance.$el
      }
      return ''
    },
    closeTooltips (destroy = false) {
      document.querySelectorAll('.tippy-popper').forEach(popper => {
        if (destroy) {
          popper._tippy && popper._tippy.destroy()
        } else {
          popper._tippy && popper._tippy.hide()
        }
      })
    },
    clickNode (clickedNode) {
      var svg = d3.select(this.$refs.mainSvg)

      let highlightSourceFn = (node) => {
        d3.select('#' + node.id).attr('opacity', 1)
        node.sourceLinks && node.sourceLinks.forEach(link => {
          d3.select('#link-' + link.index).attr('opacity', 0.6)
          highlightSourceFn(link.target)
        })
      }
      let highlightTargetFn = (node) => {
        d3.select('#' + node.id).attr('opacity', 1)
        node.targetLinks && node.targetLinks.forEach(link => {
          d3.select('#link-' + link.index).attr('opacity', 0.6)
          highlightTargetFn(link.source)
        })
      }

      
      let n = d3.select('#' + clickedNode.id)
      if (n.classed('clicked')){
        n.classed('clicked', false)
        svg.selectAll('.nodes-g').attr('opacity', 1)
        svg.selectAll('.links-g').attr('opacity', 0.2)
      }else {
        svg.selectAll('.nodes-g').attr('opacity', 0.2)
        svg.selectAll('.links-g').attr('opacity', 0.05)
        n.classed('clicked', true)
        highlightSourceFn(clickedNode)
        highlightTargetFn(clickedNode)
      }
    }
  },
  watch: {
    chartData () {
      this.drawChart()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.tippy-content
  font-family Avenir, Helvetica, Arial, sans-serif
  box-shadow: 0 5px 30px rgba(black, 0.1)
  color: #fff
  padding: 10px

svg
  .nodes-g
    cursor pointer

</style>
<style scoped lang="stylus">

</style>
